import { useMutation } from '@tanstack/react-query';
import api from '~/api';
import { useStoreId } from '~/providers/StoreUserProvider';

export const useProductSync = () => {
  const storeId = useStoreId();

  return useMutation({
    mutationFn: () => api.store(storeId).product.sync(),
  });
};
